<template>
	<VModalFinal
		modalId="add-new-project"
		:title="_tr('project.addNewProject')"
		:closeOnBackgroudClick="false"
		:showButtons="false"
		:closeButton="true"
		size="lg">
		<div class="space-y-4 p-4">
			<label class="fieldset">
				<div class="label">{{ _tr('project.name') }}:</div>
				<input class="input" v-model="newProject.name" type="text" :placeholder="_tr('project.name')" />
			</label>
			<label class="fieldset">
				<div class="label">{{ _tr('project.projectNumber') }}:</div>
				<input
					class="input"
					v-model="newProject.projectNumber"
					type="text"
					:placeholder="_tr('project.projectNumber')" />
			</label>

			<button
				class="btn btn-primary"
				@click="handleAddNewProject(() => vfm.close('add-new-project'))"
				:disabled="isProjectAdding">
				{{ _tr('project.addNewProject') }}
				<div class="loading loading-xs loading-spinner" v-if="isProjectAdding"></div>
			</button>
		</div>
	</VModalFinal>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue'
	import { useProjectStore } from '../../stores/projects.store'
	import { useI18n } from 'vue-i18n'
	import { useVfm } from '@/libs/modals'
	import VModalFinal from '@/components/VModalFinal.vue'
	import { toast } from '@/libs/toaster'
	import { useBaseStore } from '@/stores/base.store'
	import { _translations } from './_translations'

	const vfm = useVfm()
	const { t: _tr } = useI18n(_translations)
	const projectStore = useProjectStore()
	const baseStore = useBaseStore()
	const isProjectAdding = ref(false)

	const newProject = ref({
		name: '',
		projectNumber: '',
	})

	const handleAddNewProject = async (close: () => void) => {
		isProjectAdding.value = true
		try {
			await projectStore.addNewProject(newProject.value)
			await projectStore.listProjects()
			await baseStore.fetchStates()

			vfm.close('add-new-project')
		} catch (error) {
			toast.error(error.message)
		} finally {
			isProjectAdding.value = false
		}
	}
</script>
